/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowMergeBoth = createReactComponent("outline", "arrow-merge-both", "IconArrowMergeBoth", [["path", { "d": "M16 8l-4 -4l-4 4", "key": "svg-0" }], ["path", { "d": "M12 20v-16", "key": "svg-1" }], ["path", { "d": "M18 18c-4 -1.333 -6 -4.667 -6 -10", "key": "svg-2" }], ["path", { "d": "M6 18c4 -1.333 6 -4.667 6 -10", "key": "svg-3" }]]);

export { IconArrowMergeBoth as default };
//# sourceMappingURL=IconArrowMergeBoth.mjs.map
